import React from "react";
import styled from "styled-components";
import { Anchorme } from "react-anchorme";
import useLeagueSeason from "../../hooks/queryResults/useLeagueSeason";
import Util from "../../util/util";
import classnames from "classnames";

const StyledDivContainer = styled.div`
  margin-bottom: 1rem;
  background-color: white;
  padding-bottom: 0.5rem;

  & > div {
    margin-left: 1rem;
  }
`;

const StyledDivSubject = styled.div`
  font-weight: bold;
  padding: 0.25rem;
`;

const StyledDivContent = styled.div`
  padding: 0.5rem;
  white-space: break-spaces;
`;

// const StyledParagraph = styled.p`
//   margin: 0 0 0.75rem;
// `;

export default function MessageContent({
  message,
  handleShowForm,
  disableReplyButton,
}) {
  const { leagueSeason } = useLeagueSeason();
  const currentSeason = Util.getCurrentSeason();

  const isCurrentSeason =
    leagueSeason && leagueSeason.obj.season === currentSeason;

  const replyLink = isCurrentSeason && (
    <button
      onClick={handleShowForm}
      className={classnames("btn", "btn-primary")}
      disabled={disableReplyButton}
    >
      Reply to thread
    </button>
  );

  const content = message.obj.content
    ? message.obj.content.split("\n").map((section, i) => (
        <span key={i}>
          <Anchorme target={"_blank"} truncate={48}>
            {section}
          </Anchorme>
          <br />
        </span>
      ))
    : null;

  return (
    <StyledDivContainer>
      {message.obj.subject && (
        <StyledDivSubject>{message.obj.subject}</StyledDivSubject>
      )}
      {message.obj.content && <StyledDivContent>{content}</StyledDivContent>}
      <div>{replyLink}</div>
    </StyledDivContainer>
  );
}
